import { useRef, useState } from "react";

export function useToast() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const showToast = (message, opts = {}) => {
    const { type = "error" } = opts;
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type });
    timerRef.current = setTimeout(() => setToast(null), 3500);
  };

  const ToastElement = () => {
    if (!toast) return null;
    const isError = toast.type === "error";
    return (
      <div className="fixed bottom-5 right-5 z-[400] max-w-sm">
        <div className={`px-4 py-3 rounded-xl shadow-2xl text-sm font-medium text-white ${isError ? "bg-red-600" : "bg-slate-900"}`}>
          {toast.message}
        </div>
      </div>
    );
  };

  return { showToast, ToastElement };
}
